export const errorHandler = (err) => {
  return `Sorry - weather unpredictable ${err}`
}